import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Heading, Text, } from "@catchoftheday/cg-components";
import { useIsMobile } from "../../../../hooks";
export const FAQItem = ({ question, answer, faqId, handleToggle = () => false, show = false, }) => {
    const isMobile = useIsMobile();
    const questionId = `onepass-faq-question-${faqId}`;
    const answerId = `onepass-faq-answer-${faqId}`;
    return (<Accordion id={questionId} expanded={isMobile ? show : true} showDividerTop={false} borderBottom="none" mb={{
            xs: 2,
            md: 4,
        }} py={{
            xs: 4,
            md: 0,
        }}>
      {isMobile && (<AccordionSummary p={0} pr={10} height="auto" fontSize={{
                xs: "base",
                md: "xl",
            }} fontWeight="bold" color="onePass.textPrimary" onClick={() => {
                if (typeof handleToggle === "function") {
                    handleToggle();
                }
            }} onKeyDown={(event) => {
                if (typeof handleToggle === "function" && event.code === "Enter") {
                    event.preventDefault();
                    handleToggle();
                }
            }}>
          {question}
        </AccordionSummary>)}
      <AccordionDetails id={answerId} px={0} py={{ md: 6 }} mt={{ xs: 4 }}>
        {!isMobile && (<Heading.h4 fontSize="20px" lineHeight="28px" fontWeight="bold" mb={4} color="onePass.textPrimary">
            {question}
          </Heading.h4>)}
        <Text m={0} p={0} fontSize={{ xs: "sm", md: "base" }} fontWeight="medium" color="onePass.textPrimary">
          {answer}
        </Text>
      </AccordionDetails>
    </Accordion>);
};
